import { a as i } from "./index-E8vB_04G.js";
import { l as k } from "./index-b-LDu0Rp.js";
import { g as f } from "./_commonjsHelpers-CT_km90n.js";
import { s as w } from "./index-Ch-rSMgZ.js";
import { n as y } from "./nacl-fast-DmSj04OB.js";
import "ddc";
var C = w;
const p = /* @__PURE__ */ f(C), l = (o, e, t) => {
  const r = i.ChunkHeader.create({
    extraEntropy: o,
    untrustedChunkContentSizes: t,
    untrustedContentSize: e
  });
  return i.ChunkHeader.encodeDelimited(r).finish();
}, H = () => {
  const o = i.VersionHeader.create({
    version: 0
  });
  return i.VersionHeader.encodeDelimited(o).finish();
}, E = async (o, e, t, r, n, c) => {
  const a = l(
    e,
    n,
    c
  ), s = new Uint8Array([...r, ...a, ...t]), d = await self.crypto.subtle.digest("SHA-256", s), u = new m(o).encrypt(s);
  return [d, u];
}, K = async (o, e, t) => {
  const n = new m(o).decrypt(t), c = await self.crypto.subtle.digest("SHA-256", n), a = k.util.binary.hex.encode(c);
  if (a !== e)
    throw new Error(
      `Chunk hash mismatch, expected ${e}, calculated ${a}`
    );
  const s = new p.Reader(n), d = i.VersionHeader.decodeDelimited(s);
  if (d.version !== 0)
    throw new Error(`Unsupported chunk version ${d.version}`);
  return i.ChunkHeader.decodeDelimited(s), n.subarray(s.pos);
};
async function A(o, e) {
  const t = Math.ceil(o.byteLength / e), r = [];
  for (let n = 0; n < t; n++) {
    const c = o.slice(n * e, n * e + e), a = H(), s = l(y.randomBytes(16), null, null), d = new Uint8Array([
      ...a,
      ...s
    ]), h = new Uint8Array([...d, ...c]), u = await self.crypto.subtle.digest("SHA-256", h);
    r.push({
      contentSize: c.length,
      contentWithHeaders: h,
      hash: u
    });
  }
  return r;
}
function S(o) {
  const e = H();
  return new TransformStream({
    async transform({ data: t, progress: r }, n) {
      const c = (/* @__PURE__ */ new Date()).getTime(), [a, s] = await E(
        o,
        y.randomBytes(16),
        t,
        e,
        null,
        null
      );
      n.enqueue({
        data: {
          chunkHash: a,
          encryptedChunk: s
        },
        progress: r
      });
      const d = (/* @__PURE__ */ new Date()).getTime();
      console.info(`[client] Encryption took ${d - c} ms`);
    }
  });
}
class m {
  encKey;
  constructor(e) {
    this.encKey = e;
  }
  encrypt(e) {
    const t = y.randomBytes(y.secretbox.nonceLength), r = y.secretbox(e, t, this.encKey), n = i.EncryptionHeader.create({
      chilyKey: {
        encryptionNonce: t
      }
    }), c = i.EncryptionHeader.encodeDelimited(
      n
    ).finish();
    return new Uint8Array([
      ...c,
      ...r
    ]);
  }
  decrypt(e) {
    const t = new p.Reader(e), r = i.EncryptionHeader.decodeDelimited(t);
    if (!r.chilyKey || !r.chilyKey.encryptionNonce)
      throw new Error("Malformed EncryptionHeader, nonce is not set");
    const n = y.secretbox.open(
      e.subarray(t.pos),
      r.chilyKey.encryptionNonce,
      this.encKey
    );
    if (!n)
      throw new Error("Decryption failed, key or nonce incorrect");
    return n;
  }
}
export {
  m as StorageCipher,
  A as createChunks,
  E as createEncryptedChunk,
  S as createEncryptedChunks,
  H as createVersionHeader,
  K as decryptChunk
};
//# sourceMappingURL=storage.js.map
